import { colors } from "./colors";

/**
 * สถานะใบแจ้งซ่อม — ต้องตรงกับค่าที่ backend ส่งมา
 * NOTE: SUCESS สะกด S ตัวเดียวตาม backend ห้ามแก้ถ้าไม่ได้แก้ฝั่ง API พร้อมกัน
 */
export enum REPAIR_STATUS {
  WAITING = "WAITING",
  RECEIVE = "RECEIVE",
  ADDITIONAL = "ADDITIONAL",
  SUCESS = "SUCESS",
}

/** value ที่รับจาก API -> label ที่โชว์ใน timeline ประวัติการดำเนินงาน */
export const REPAIR_STATUS_LABEL: Record<string, string> = {
  [REPAIR_STATUS.WAITING]: "แจ้งเรื่อง",
  [REPAIR_STATUS.RECEIVE]: "รับคำร้อง",
  [REPAIR_STATUS.ADDITIONAL]: "แจ้งเรื่องเพิ่มเติม",
  [REPAIR_STATUS.SUCESS]: "ดำเนินการแล้วเสร็จ",
};

/** สีของสถานะ (ใช้ palette เดิมจาก constants/colors ให้ตรงกับคอลัมน์สถานะในตาราง) */
export const REPAIR_STATUS_COLOR: Record<string, string> = {
  [REPAIR_STATUS.WAITING]: colors.lightOrange,
  [REPAIR_STATUS.RECEIVE]: colors.lightOrange,
  // ยังไม่จบงาน -> โทนเดียวกับ WAITING/RECEIVE
  [REPAIR_STATUS.ADDITIONAL]: colors.lightOrange,
  [REPAIR_STATUS.SUCESS]: colors.green,
};

/** fileType ของไฟล์แนบเรื่องที่แจ้งเพิ่ม — ต้องตรงกับที่ POST /repair/additional คืนมา */
export const REPAIR_ADDITIONAL_FILE_TYPE = "repair-additional";

/** สถานะที่ยังไม่รู้จัก ให้โชว์ค่าดิบไว้ก่อน ดีกว่าโชว์ "-" แล้วข้อมูลหายไปเฉยๆ */
export const repairStatusLabel = (status?: string) =>
  (status && REPAIR_STATUS_LABEL[status]) || status || "-";

export const repairStatusColor = (status?: string) =>
  (status && REPAIR_STATUS_COLOR[status]) || colors.gray;
